import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { colors } from './colors.js';
import { Themes } from '../theme.types.js';
import neutral from '../neutral/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var components = {
  name: Themes.HERKKU,
  accordion: _objectSpread(_objectSpread({}, neutral.components.accordion), {}, {
    "default": _objectSpread(_objectSpread({}, neutral.components.accordion["default"]), {}, {
      focusColor: colors.primary200
    })
  }),
  alert: _objectSpread(_objectSpread({}, neutral.components.alert), {}, {
    errorBackgroundColor: colors.error50,
    errorTextColor: colors.error900,
    warningBackgroundColor: colors.warning50,
    warningTextColor: colors.warning900,
    infoBackgroundColor: colors.info50,
    infoTextColor: colors.info900,
    successBackgroundColor: colors.success50,
    successTextColor: colors.success900
  }),
  button: _objectSpread(_objectSpread({}, neutral.components.button), {}, {
    focusColor: colors.primary200,
    primary: _objectSpread(_objectSpread({}, neutral.components.button.primary), {}, {
      background: colors.primary,
      focusBackground: colors.primary,
      activeBackground: colors.primary,
      color: colors.white,
      hoverBackground: colors.primary900,
      disabledBackground: colors.primary100,
      disabledColor: colors.white
    }),
    "default": {
      color: colors.primary,
      hoverColor: colors.primary900,
      disabledColor: colors.primary100,
      borderColor: colors.primary
    },
    link: _objectSpread(_objectSpread({}, neutral.components.button.link), {}, {
      color: colors.primary,
      hoverColor: colors.primary900,
      disabledColor: colors.primary100
    }),
    text: {
      color: colors.grey800,
      hoverColor: colors.primary900,
      disabledColor: colors.grey400
    }
  }),
  checkbox: _objectSpread(_objectSpread({}, neutral.components.checkbox), {}, {
    borderColor: colors.grey,
    checkedBorderColor: colors.primary,
    disabledBorderColor: colors.primary,
    checkedBackgroundColor: colors.primary,
    hoverCheckedBorderColor: colors.primary900,
    hoverCheckedBackgroundColor: colors.primary900,
    hoverBorderColor: colors.primary,
    tickColor: colors.white
  }),
  datePicker: _objectSpread(_objectSpread({}, neutral.components.datePicker), {}, {
    color: colors.grey,
    hoverColor: colors.grey900,
    borderColor: colors.grey300,
    borderFocusColor: colors.primary,
    highlightColor: colors.primary900,
    highlightFocusColor: colors.primary800
  }),
  drawer: _objectSpread(_objectSpread({}, neutral.components.drawer), {}, {
    focusColor: colors.primary200
  }),
  form: _objectSpread({}, neutral.components.form),
  grid: _objectSpread({}, neutral.components.grid),
  modal: _objectSpread({}, neutral.components.modal),
  popover: _objectSpread({}, neutral.components.popover),
  input: _objectSpread(_objectSpread({}, neutral.components.input), {}, {
    highlightColor: colors.grey300,
    highlightHoverColor: colors.primary500,
    highlightFocusColor: colors.primary200,
    disabledBackgroundColor: colors.grey200,
    buttonTextColor: colors.white,
    buttonBackgroundColor: colors.primary800,
    buttonHoverBackgroundColor: colors.primary900,
    buttonDisabledBackgroundColor: colors.grey400,
    warningColor: colors.warning800,
    warningShadow: colors.warning200,
    errorColor: colors.error800,
    errorShadow: colors.error200,
    selectedItemBgColor: colors.primary50
  }),
  select: _objectSpread(_objectSpread({}, neutral.components.select), {}, {
    color: colors.grey,
    borderFocusColor: colors.primary200,
    hoverItemBgColor: colors.grey100,
    selectedItemBgColor: colors.primary50
  }),
  "switch": _objectSpread(_objectSpread({}, neutral.components["switch"]), {}, {
    onBackgroundColor: colors.primary,
    onBackgroundColorHover: colors.primary900,
    onBackgroundColorDisabled: colors.primary100,
    focusColor: colors.primary
  }),
  radio: _objectSpread(_objectSpread({}, neutral.components.radio), {}, {
    color: colors.grey800,
    borderColor: colors.grey800,
    checkedBorderColor: colors.primary800,
    checkedDotColor: colors.primary800,
    focusColor: colors.primary200,
    hoverColor: colors.primary900,
    shadowColor: colors.secondary100,
    disabledColor: colors.grey400
  }),
  tab: _objectSpread(_objectSpread({}, neutral.components.tab), {}, {
    color: colors.grey,
    focusColor: colors.primary,
    shadowColor: colors.primary100,
    hoverColor: colors.primary900,
    disabledColor: colors.primary100,
    defaultTabColor: colors.grey800,
    defaultDisabledTabColor: colors.grey400
  }),
  tag: _objectSpread(_objectSpread({}, neutral.components.tag), {}, {
    color: colors.white,
    focusColor: colors.primary300,
    backgroundColor: colors.primary,
    hoverColor: colors.primary900,
    disabledColor: colors.primary100,
    defaultTagColor: colors.grey,
    defaultDisabledTagColor: colors.grey500,
    defaultTagBackgroundColor: colors.white,
    light: _objectSpread(_objectSpread({}, neutral.components.tag.light), {}, {
      textColor: colors.primary900,
      backgroundColor: colors.primary50,
      disabledColor: colors.primary200,
      disabledBackgroundColor: colors.primary50,
      hoverBackgroundColor: colors.primary100
    })
  })
};

export { components };
//# sourceMappingURL=components.js.map
